import { z } from "zod";

import { basicsSchema, minimalBasicsSchema, defaultBasics, deminimalizeBasics } from "./basics";
import { defaultMetadata, metadataSchema } from "./metadata";
import {
  sectionsSchema,
  defaultSections,
  minimalSectionsSchema,
  deminimalizeSections,
} from "./sections";

// Schema
export const resumeDataSchema = z.object({
  searchKeyword: z
    .string()
    .describe("One keyword to search for similar jobs, for example 'Senior Frontend Developer'")
    .optional(),
  basics: basicsSchema,
  sections: sectionsSchema,
  metadata: metadataSchema,
});

export const minimalResumeDataSchema = resumeDataSchema
  .pick({
    searchKeyword: true,
  })
  .extend({
    basics: minimalBasicsSchema,
    sections: minimalSectionsSchema,
  });

// Type
export type ResumeData = z.infer<typeof resumeDataSchema>;
export type MinimalResumeData = z.infer<typeof minimalResumeDataSchema>;

// Defaults
export const defaultResumeData: ResumeData = {
  searchKeyword: "",
  basics: defaultBasics,
  sections: defaultSections,
  metadata: defaultMetadata,
};

export const deminimalizeResumeData = (resumeData: MinimalResumeData): ResumeData => {
  return {
    ...defaultResumeData,
    searchKeyword: resumeData.searchKeyword,
    basics: deminimalizeBasics(resumeData.basics),
    sections: deminimalizeSections(resumeData.sections),
  };
};

export * from "./basics";
export * from "./metadata";
export * from "./sample";
export * from "./sections";
export * from "./shared";
export * from "./metrics";
export * from "./events";
export * from "./admin";
export * from "./resume-optimizer";
